// extension of ObjectFeaturesEnum, where all bits were full
export enum ObjectFeatures2Enum {
    None = 0,
    AdditionalContent = 1,
    ModifyPollingSchedule = 2,
    HasPlungerStatusTag = 4,
    HasPlungerImageView = 8,
   
};
